import { FC } from 'react'

import { Router } from './pages'

export interface AppProps { }

export const App: FC<AppProps> = () => <Router />
